import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver } from 'react-hook-form';
import { OneGroupT, UpdateGroupT } from 'shared/api/types/services';
import * as Yup from 'yup';
import initDefaultSchema from '../yupConfig';

initDefaultSchema();

// Update
export type UpdateFormT = UpdateGroupT['request'];
export const getUpdateValues = (values?: OneGroupT['response']): UpdateFormT => ({
  name: values?.name,
  note: values?.note,
  link: values?.link,
  sheetLink: values?.sheetLink,
});
const updateSchema: Yup.ObjectSchema<UpdateFormT> = Yup.object({
  name: Yup.string().required(),
  note: Yup.string().required(),
  link: Yup.string().required(),
  sheetLink: Yup.string().required(),
});
export const updateResolver = yupResolver(updateSchema) as Resolver<UpdateFormT>;

// Create
export type CreateFormT = UpdateGroupT['request'];
export const getCreateValues = (values?: OneGroupT['response']): CreateFormT => ({
  name: values?.name,
  note: values?.note,
  link: values?.link,
  sheetLink: values?.sheetLink,
});
const createSchema: Yup.ObjectSchema<CreateFormT> = Yup.object({
  name: Yup.string().required(),
  note: Yup.string().required(),
  link: Yup.string().required(),
  sheetLink: Yup.string().required(),
});
export const createResolver = yupResolver(createSchema) as Resolver<CreateFormT>;
